import script from "./LandlordNotification.vue?vue&type=script&setup=true&lang=js"
export * from "./LandlordNotification.vue?vue&type=script&setup=true&lang=js"

import "./LandlordNotification.vue?vue&type=style&index=0&id=15d9f767&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15d9f767"]])

export default __exports__